export const JiraAlignLogoBrand = () => (
  <svg
    width="213"
    height="48"
    viewBox="0 0 213 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.254 8.52734H56.395V29.5523C56.395 35.1193 53.957 38.9383 48.252 38.9383C46.09 38.9383 44.434 38.5703 43.283 38.1563V34.1533C44.525 34.6603 46.044 34.9353 47.561 34.9353C51.058 34.9353 52.253 32.8193 52.253 29.8293V8.52734H52.254Z"
      fill="#172B4D"
    />
    <path
      d="M63.892 6.91846C65.502 6.91846 66.652 7.93046 66.652 9.67846C66.652 11.4265 65.503 12.4395 63.892 12.4395C62.281 12.4395 61.131 11.4265 61.131 9.67846C61.131 7.93046 62.281 6.91846 63.892 6.91846ZM61.868 15.7515H65.825V38.7535H61.868V15.7515Z"
      fill="#172B4D"
    />
    <path
      d="M75.7589 38.7531H71.8949V15.7511H75.7589V19.7991C77.0929 17.0851 79.3939 15.1531 83.9029 15.4291V19.2931C78.8419 18.7871 75.7589 20.3051 75.7589 25.1821V38.7531Z"
      fill="#172B4D"
    />
    <path
      d="M102.44 34.612C100.968 37.649 98.208 39.213 94.666 39.213C88.547 39.213 85.465 34.015 85.465 27.252C85.465 20.765 88.685 15.29 95.126 15.29C98.484 15.29 101.061 16.809 102.44 19.799V15.751H106.397V38.753H102.44V34.612ZM95.723 35.533C99.266 35.533 102.44 33.278 102.44 28.172V26.332C102.44 21.226 99.542 18.971 96.183 18.971C91.721 18.971 89.42 21.915 89.42 27.252C89.42 32.773 91.628 35.533 95.723 35.533Z"
      fill="#172B4D"
    />
    <path
      d="M121.161 31.9443L118.631 38.7533H113.984L125.9 8.52734H131.144L143.06 38.7533H138.414L135.885 31.8993C133.17 32.4513 130.823 32.7273 128.385 32.7273C126.084 32.7273 123.739 32.4513 121.162 31.9453L121.161 31.9443ZM134.641 28.4483L128.521 11.8863L122.402 28.4943C124.657 28.8623 126.543 29.0463 128.383 29.0463C130.315 29.0463 132.293 28.8173 134.64 28.4483H134.641Z"
      fill="#172B4D"
    />
    <path
      d="M151.98 38.8922C148.209 38.8922 145.816 37.0972 145.816 32.8652V6.13623H149.773V32.4052C149.773 34.4752 151.152 35.2122 152.855 35.2122C153.269 35.2122 153.544 35.2122 154.005 35.1662V38.7082C153.683 38.8002 152.991 38.8932 151.98 38.8932V38.8922Z"
      fill="#172B4D"
    />
    <path
      d="M159.846 6.91846C161.455 6.91846 162.606 7.93046 162.606 9.67846C162.606 11.4265 161.456 12.4395 159.846 12.4395C158.236 12.4395 157.084 11.4265 157.084 9.67846C157.084 7.93046 158.234 6.91846 159.846 6.91846ZM157.821 15.7515H161.778V38.7535H157.821V15.7515Z"
      fill="#172B4D"
    />
    <path
      d="M183.26 34.612C181.787 37.649 179.028 39.213 175.485 39.213C169.413 39.213 166.378 34.015 166.378 27.252C166.378 20.765 169.552 15.29 175.946 15.29C179.305 15.29 181.882 16.809 183.26 19.799V15.751H187.125V36.683C187.125 43.446 183.951 48 175.715 48C171.852 48 169.735 47.494 167.527 46.758V42.894C170.056 43.722 172.679 44.274 175.531 44.274C181.281 44.274 183.26 41.192 183.26 36.914V34.612ZM176.543 35.533C180.086 35.533 183.26 33.278 183.26 28.172V26.332C183.26 21.226 180.362 18.971 177.004 18.971C172.541 18.971 170.24 21.915 170.24 27.252C170.24 32.773 172.449 35.533 176.543 35.533Z"
      fill="#172B4D"
    />
    <path
      d="M212.654 38.753H208.697V24.859C208.697 20.718 207.041 18.879 203.269 18.879C199.589 18.879 197.058 21.317 197.058 25.964V38.753H193.101V15.751H197.058V19.523C198.531 16.808 201.244 15.29 204.328 15.29C209.617 15.29 212.654 18.925 212.654 25.273V38.752V38.753Z"
      fill="#172B4D"
    />
    <path
      d="M0 10.1895C0 15.5725 4.383 19.9365 9.761 19.9365H18.802V29.0065H28.563V11.7325C28.563 10.8805 27.873 10.1895 27.022 10.1895H0Z"
      fill="url(#paint0_linear_818_508)"
    />
    <path
      d="M28.564 38.7535C28.564 33.3705 24.181 29.0065 18.803 29.0065H9.761V19.9365H0V37.2105C0 38.0625 0.69 38.7535 1.541 38.7535H28.564Z"
      fill="url(#paint1_linear_818_508)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_508"
        x1="11.974"
        y1="31.4725"
        x2="14.194"
        y2="20.0505"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.15" stopColor="#0055CC" />
        <stop offset="0.522" stopColor="#0B63DE" />
        <stop offset="1" stopColor="#1D7AFC" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_818_508"
        x1="16.59"
        y1="17.4695"
        x2="14.37"
        y2="28.8925"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.15" stopColor="#0055CC" />
        <stop offset="0.522" stopColor="#0B63DE" />
        <stop offset="1" stopColor="#1D7AFC" />
      </linearGradient>
    </defs>
  </svg>
);
